<template>
    <div>
        <base-header class="pb-6 pb-2 pt-6 pt-md-6" type="gray-100">
          
        </base-header>

        <template v-if="loading">
            <div class="m-2">
                <skeleton altura="400px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
            </div>
        </template>

        <div class="container-fluid" v-if="!loading">
            <div class="row">
                <div class="col-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Cadastro de Contas</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-12">
                                            <base-input alternative=""
                                                label="Descritivo"
                                                input-classes="form-control-alternative"
                                                v-model="model.descritivo"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-4">
                                            <base-input alternative=""
                                                label="Data de Vencimento"
                                                input-classes="form-control-alternative"
                                                type="date"
                                                v-model="model.data_vencimento"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-4 col-12">
                                            <div class="form-group has-label">
                                                <label class="form-control-label">Tipo</label>

                                                <v-select  :options="tipoList"  label="nome" class="form-control form-control-alternative" v-model="model.tipo">
                                                    <template #option="option">
                                                        {{ option.nome }}
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-4 col-12">
                                            <base-input alternative=""
                                                label="Valor"
                                                input-classes="form-control-alternative"
                                                v-model="model.valor"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-2">
                                            <base-input alternative=""
                                                label="Parcelamento"
                                                sublabel="(zero para nenhum)"
                                                input-classes="form-control-alternative"
                                                v-model="model.parcelamento"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-4 col-12">
                                            <div class="form-group has-label">
                                                <label class="form-control-label">Pago?</label>

                                                <v-select  :options="pagoFlag"  label="nome" class="form-control form-control-alternative" v-model="model.pago">
                                                    <template #option="option">
                                                        {{ option.nome }}
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div  v-if="!loading2" class="text-right">
                                 <base-button type="primary" @click="salvar()">Salvar Conta</base-button>
                                </div>
               
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import financeiro from '@/cflow/financeiro.js'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import router from '@/router'
import storage from 'storage';
//import agenda from '@/cflow/agendaProtetica.js'
  //import parametros from "@/cflow/parametros.js";
  //import BaseButton from '../../components/BaseButton.vue';
  //import BaseInput from '../../components/BaseInput.vue';
  //import Multiselect from "vue-multiselect";

    
  export default {
    name: 'tables',
    components: {
        vSelect
     // Multiselect,
      //BaseInput,
    },
    
    methods: {
        salvar: function() {

            
            const _this = this;
            const _id = _this.$route.params.id || '0';
            const user = storage.get("user");
            const form = _this.model;

            form.tipo = form.tipo.valor;
            form.pago = form.pago.flag;
            form.id_lab = user.id;

            _this.loading = true;

            financeiro.salvar(_id, form).then(() => {
                router.push('/financeiro');
            });
        },

        detalhes: function(_id) {
            const _this = this;
            _this.loading = true; 

            financeiro.detalhes(_id).then(res => {
                _this.model = res;
                _this.model.lab_id = res.id_lab;
                _this.loading = false;

                let tipo = _this.tipoList.filter(item => item.valor === _this.model.tipo)[0];
                _this.model.tipo = tipo;

                let pago = _this.pagoFlag.filter(item => item.flag === _this.model.pago)[0];
                _this.model.pago = pago;

                _this.model.valor = _this.model.valor.toLocaleString('pt-br', {minimumFractionDigits: 2});
            })
        }
    },
    data() {
      return {
        txt1: 'Salvar',
        tipo: null,
        id: null,
        tipoList: [{'nome': 'Pagamento', 'valor': 'PAGAR'}, {'nome': 'Recebimento', 'valor': 'RECEBER'}],
        pagoFlag: [{'nome': 'SIM', flag: 1}, {'nome': 'NÃO', flag: 0}],
        hasSuccess: false,
        hasError: false,
        loading: false,
        loading2: false,
        dated: '',
        model: {
          data_vencimento: '',
          descritivo: '',
          tipo: '',
          valor: '',
          parcelamento: 0,
          pago: {'nome': 'NÃO', flag: 0},
          lab_id: 0
        }
      }
    },

     mounted(){

        const _id = this.$route.params.id || '';
        if(_id) this.detalhes(_id)

    }
  };
</script>
<style>
.height, .ProseMirror {
    min-height: 300px;
}
.select {
    width: 100%;
    padding: 5px 5px;
}
.vs__dropdown-toggle {
    border: none !important;
}
</style>
